import React from 'react';

const QualityBanner = () => {
  return (
    <section style={{ marginTop: '76px' }} id="attraction">
      <div
        className="bg-image bg-fixed text-center"
        style={{
          backgroundImage: "url('/images/Bitejoy/1767899802372.jpg')",
          height: '585.282px',
        }}
      >
        <div className="mask">
          <div className="d-flex justify-content-center align-items-center h-100 mt-4">
            <div>
              <h1 className="display-1" style={{ color: '#ffffff' }}>
                Premium Quality Ever
              </h1>

              <h4 className="font-weight-light mb-4" style={{ color: '#fff' }}>
                We proudly follow an A-to-Z in-house process, ensuring
                freshness, purity, and consistency in every bite. With the
                blessings of Bappa and the love of our customers, we are
                building a brand that stands for honesty, innovation, and
                happiness.
              </h4>
              <div className="image" style={{ align: 'center' }}>
                <img
                  src="/images/Bitejoy/3-flowers.png"
                  alt="flowers"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualityBanner;
